import { montaHtmlCartao } from './cartao.js';

const POR_PAGINA = 30;

export function criaLista(elemento, aoEscolher) {
  let todos = [];
  let mostrando = 0;

  function acrescenta() {
    const lote = todos.slice(mostrando, mostrando + POR_PAGINA);
    const html = lote
      .map((f) => `<article class="item-lista" tabindex="0" role="button"
                     data-slug="${f.properties.slug}"
                     aria-label="Ver detalhes de ${f.properties.titulo}">
                     ${montaHtmlCartao(f.properties)}
                   </article>`)
      .join('');
    elemento.querySelector('.grade').insertAdjacentHTML('beforeend', html);
    mostrando += lote.length;
    const btn = elemento.querySelector('#ver-mais');
    if (btn) btn.hidden = mostrando >= todos.length;
  }

  function desenha(features) {
    todos = features;
    mostrando = 0;
    if (features.length === 0) {
      elemento.innerHTML =
        '<p class="lista-vazia">Nenhum empreendimento encontrado com esses filtros.</p>';
      return;
    }
    elemento.innerHTML =
      '<div class="grade"></div><button type="button" id="ver-mais">Ver mais</button>';
    elemento.querySelector('#ver-mais').addEventListener('click', acrescenta);
    acrescenta();
  }

  // Delegação: vale também para os itens carregados depois
  elemento.addEventListener('click', (e) => {
    if (e.target.closest('a')) return; // deixa os CTAs seguirem
    const item = e.target.closest('.item-lista');
    if (item) aoEscolher(item.dataset.slug);
  });
  elemento.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target.closest('a')) return;
    const item = e.target.closest('.item-lista');
    if (item) { e.preventDefault(); aoEscolher(item.dataset.slug); }
  });

  return { desenha };
}
